import AsyncDataGrid from './AsyncDataGrid';
import AsyncTable from './AsyncTable';
import AsyncPagination from './AsyncPagination';
import AsyncDataGridFilters from './AsyncDataGridFilters';
import AsyncDataGridFilterSearch from './AsyncDataGridFilterSearch';
AsyncDataGrid.Table = AsyncTable;
AsyncDataGrid.Pagination = AsyncPagination;
AsyncDataGrid.Filters = AsyncDataGridFilters;
AsyncDataGrid.FilterSearch = AsyncDataGridFilterSearch;
export default AsyncDataGrid;